import { styled } from "leva/plugin";

export const Overlay = styled("div", {
	position: "fixed",
	top: 0,
	left: 0,
	width: "100%",
	height: "100%",
	backgroundColor: "$elevation3",
	zIndex: 999,
	display: "flex",
	justifyContent: "center",
	alignItems: "center",
});

export const StyledModal = styled("div", {
	width: "300px",
	height: "auto",
	backgroundColor: "$elevation3",
	borderRadius: "5px",
	padding: "4px 16px",
	position: "relative", // Change to relative
	display: "flex",
	flexDirection: "column",
	gap: "5px",
});

export const ModalHeader = styled("div", {
	display: "flex",
	justifyContent: "space-between",
	alignItems: "center",
	marginBottom: "10px",
});

export const ModalTitle = styled("div", {
	color: "#fefefe",
	fontSize: "16px", // Change to static size
});

export const CloseButton = styled("div", {
	color: "#fefefe",
	fontSize: "12px",
	cursor: "pointer",
});

export const SaveButton = styled("button", {
	width: "100%", // Take up the whole width
	height: "30px", // Change to static size
	backgroundColor: "$accent1",
	color: "$highlight3",
	border: "none",
	borderRadius: "4px",
	cursor: "pointer",
	transition: "background-color 0.2s ease, transform 0.2s ease",

	"&:hover": {
		backgroundColor: "$accent2",
		// transform: "scale(1.05)", // Add on-hover animation
	},

	"&:active": {
		backgroundColor: "$accent3",
	},

	"&:focus": {
		outline: "none",
	},
});
